import { h } from 'vue'
import assetSrc from '~/assets/svg/chevron-down.svg'
import AtomBubble from '~/components/atoms/bubble/bubble.vue'
import AtomButton from '~/components/atoms/button/button.vue'
import MoleculeRatingStars from '~/components/molecules/rating-stars/rating-stars.vue'
import MoleculeTestimonial from '~/components/molecules/testimonial/testimonial.vue'
import OrganismCompaniesTrust from '~/components/organisms/companies-trust/companies-trust.vue'
import OrganismHubspotNativeForm from '~/components/organisms/hubspot-native-form/hubspot-native-form.vue'
import OrganismPlayerVideo from '~/components/organisms/player-video/player-video.vue'
import OrganismRichText from '~/components/organisms/rich-text/rich-text.vue'
import UiComponentContainer from '~ui/components/container/container.vue'
import UiComponentHeading from '~ui/components/heading/heading.vue'
import UiComponentIcon from '~ui/components/icon/icon.vue'
import UiComponentImage from '~ui/components/image/image.vue'
import UiComponentParagraph from '~ui/components/paragraph/paragraph.vue'
import UiComponentWrapper from '~ui/components/wrapper/wrapper.vue'

const Functional = (props) => {
  return h(
    UiComponentWrapper,
    {
      class: [
        'header',
        { customizable: props.record.forPersonalization },
        { 'has-scroll-indicator': props.page.activateArrowToScrollDown },
      ],
    },
    () => [
      h(AtomBubble, { color: 'pale-red' }),
      h(
        UiComponentContainer,
        {
          class: [
            'flex-col',
            'lg:flex-row',
            'lg:justify-between',
            'lg:items-start',
            { 'lg:flex-row-reverse': props.record.imagePosition === 'Left' },
          ],
        },
        () => [
          h(
            UiComponentWrapper,
            {
              class: 'content',
            },
            () => [
              h(
                UiComponentHeading,
                {},
                () => [props.record.title],
              ),
              props.record.displayStarsRating
              && h(MoleculeRatingStars, {
                hover: props.customersReviewLogoSection?.hoverText,
              }, {
                rating: () => props.customersReviewLogoSection?.reviews,
              }),
              h(OrganismRichText, {
                class: 'description',
                content: [
                  {
                    __typename: 'ContentTextHtmlRecord',
                    text: props.record.text,
                  },
                ],
              }),
              props.record.displayVideoInsteadOfText
              && props.record.video
              && props.record.video.video?.video?.streamingUrl
              && props.record.video.thumbnail?.url
              && h(OrganismPlayerVideo, {
                autoPlay: false,
                class: 'video-explainer',
                posterSrc: props.record.video.thumbnail.url,
                subtitles:
                    props.record.addSubtitlesOnAVideo && props.record.subtitles
                      ? props.record.subtitles
                      : [],
                videoSrc: props.record.video.video.video.streamingUrl,
              }),
              h(UiComponentWrapper, { class: 'buttons' }, () => [
                props.record.ctaTryForFree
                && h(
                  AtomButton,
                  {
                    ...props.primaryButton,
                    label: 'Header section CTA',
                    size: 'l',
                  },
                  () => [props.record.ctaTryForFree],
                ),
                props.record.ctaGetADemo
                && !props.page.ctaCustom
                && !props.page.chiliPiperCalendarUrl
                && h(
                  AtomButton,
                  {
                    ...props.secondaryButton,
                    label: 'Header section CTA',
                    size: 'l',
                    type: props.record.ctaTryForFree ? 'secondary' : 'primary',
                    onClick: () => {
                      props.secondaryButton.onClick()
                    },
                  },
                  () => [props.record.ctaGetADemo],
                ),
                props.record.ctaGetADemo
                && !props.page.ctaCustom
                && props.page.chiliPiperCalendarUrl
                && h(
                  AtomButton,
                  {
                    ...props.mainButton,
                    label: 'Header section CTA',
                    size: 'l',
                    type: props.record.ctaTryForFree ? 'secondary' : 'primary',
                    onClick: () => props.displayChiliPiperForm(),
                  },
                  () => [props.record.ctaGetADemo],
                ),
                props.page.ctaCustom
                && h(
                  AtomButton,
                  {
                    action: 'Button clicked',
                    attributes: {
                      action: props.page.ctaCustom.slug,
                    },
                    label: 'Header section CTA',
                    size: 'l',
                    type: props.record.ctaTryForFree ? 'secondary' : 'primary',
                    to: props.page.ctaCustom.slug,
                  },
                  () => [props.page.ctaCustom.slot],
                ),
              ]),
              h(UiComponentWrapper, { class: 'medals' }, () => [
                h(UiComponentWrapper, { class: 'row' }, () => [
                  h(UiComponentImage, {
                    alt: 'top 100 fastest growing product of 2022',
                    class: 'first',
                    expectedSize: 72,
                    height: 312,
                    source:
                      'https://livestorm.imgix.net/1127/1651844374-top-100-fastest-growing-product-2022.png',
                    width: 240,
                  }),
                  h(UiComponentImage, {
                    alt: 'best usability mid market winter 2022',
                    expectedSize: 72,
                    height: 312,
                    source:
                      'https://livestorm.imgix.net/1127/1651842897-best-usability-mid-market-winter-2022.png',
                    width: 240,
                  }),
                  h(UiComponentImage, {
                    alt: 'leader winter 2022',
                    expectedSize: 72,
                    height: 312,
                    source:
                      'https://livestorm.imgix.net/1127/1651842903-leader-winter-2022.png',
                    width: 240,
                  }),
                  h(UiComponentImage, {
                    alt: 'best relationship mid market winter 2022',
                    expectedSize: 72,
                    height: 312,
                    source:
                      'https://livestorm.imgix.net/1127/1651842894-best-relationship-mid-market-winter-2022.png',
                    width: 240,
                  }),
                ]),
                h(UiComponentWrapper, { class: 'row' }, () => [
                  h('span', { class: 'empty' }),
                  h(UiComponentImage, {
                    alt: 'high performer enterprise winter 2022',
                    expectedSize: 72,
                    height: 312,
                    source:
                      'https://livestorm.imgix.net/1127/1651842901-high-performer-enterprise-winter-2022.png',
                    width: 240,
                  }),
                  h(UiComponentImage, {
                    alt: 'easiest setup mid market winter 2022',
                    class: 'last',
                    expectedSize: 72,
                    height: 312,
                    source:
                      'https://livestorm.imgix.net/1127/1651842899-easiest-setup-mid-market-winter-2022.png',
                    width: 240,
                  }),
                  h('span', { class: 'empty' }),
                ]),
              ]),
              props.record.displayTeiStats
              && h(UiComponentWrapper, { class: 'tei-stats' }, () => [
                h(UiComponentWrapper, { class: 'head' }, () => [
                  h(
                    UiComponentParagraph,
                    {
                      class: 'title',
                      slot: 'default',
                    },
                    () => [props.teiStatistics.title],
                  ),
                  h(UiComponentImage, {
                    alt: props.teiStatistics.logo.alt,
                    expectedSize: 122,
                    height: props.teiStatistics.logo.height,
                    source: props.teiStatistics.logo.url,
                    width: props.teiStatistics.logo.width,
                  }),
                ]),
                h(UiComponentWrapper, { class: 'stats' }, () => [
                  props.teiStatistics.statistics.map((stat) => {
                    return h(UiComponentWrapper, { class: 'stat' }, () => [
                      h(UiComponentIcon, {
                        type: stat.icon.name,
                      }),
                      h(UiComponentParagraph, { slot: 'default' }, () => [
                        h('span', { slot: 'default' }, [`${stat.value} `]),
                        stat.description,
                      ]),
                    ])
                  }),
                ]),
              ]),
              props.record.displayCustomersLogos
              && h(UiComponentWrapper, { class: 'customers-logo' }, () => [
                h(OrganismCompaniesTrust, {
                  companies: props.record.customersLogo
                    .filter(customer => customer.logoColor?.url)
                    .map(customer => ({
                      alt: customer.logoColor?.alt,
                      height: customer.logoColor?.height,
                      url: customer.logoColor?.url,
                      width: customer.logoColor?.width,
                    })),
                  forPersonalization: props.record.forPersonalization,
                  type: props.page.chiliPiperCalendarUrl
                    ? 'chilipiper-form'
                    : 'modal-form',
                }, {
                  experience: () =>
                    props.record.forPersonalization
                      ? props.record.customerLogoYourCompanyText
                      : undefined,
                  heading: () => props.record.customerLogoText,
                }),
              ]),
              props.record.displayG2ClientsTestimonials
              && h(UiComponentWrapper, { class: 'g2-testimonial' }, () => [
                h(
                  MoleculeTestimonial,
                  {
                    testimonial: {
                      customer: {
                        avatar:
                            props.record.g2CustomerTestimonial.authorPicture,
                        name: props.record.g2CustomerTestimonial
                          .authorUserStory,
                        position:
                            props.record.g2CustomerTestimonial.authorPosition,
                      },
                      logo: props.record.g2CustomerTestimonial.logoColor,
                      quote: props.record.g2CustomerTestimonial.quote,
                    },
                    variant: 'compact',
                  },
                ),
              ]),
              props.record.badges
              && h('div', { class: 'badges' }, () => [
                props.componentCertification.capterra
                && props.componentCertification.capterra.medal
                && h(UiComponentImage, {
                  alt: props.componentCertification.capterra.medal
                    .alt,
                  class: 'capterra',
                  expectedSize: 62,
                  height:
                        props.componentCertification.capterra.medal
                          .height,
                  orientation:
                        props.componentCertification.capterra.medal
                          .height
                          > props.componentCertification.capterra.medal.width
                          ? 'landscape'
                          : 'portrait',
                  source:
                        props.componentCertification.capterra.medal.url,
                  width:
                        props.componentCertification.capterra.medal.width,
                }),
                props.componentCertification.g2
                && props.componentCertification.g2.medal
                && h(UiComponentImage, {
                  alt: props.componentCertification.g2.medal.alt,
                  class: 'g2',
                  expectedSize: 62,
                  height:
                        props.componentCertification.g2.medal.height,
                  orientation:
                        props.componentCertification.g2.medal.height
                        > props.componentCertification.g2.medal.width
                          ? 'landscape'
                          : 'portrait',
                  source: props.componentCertification.g2.medal.url,
                  width: props.componentCertification.g2.medal.width,
                }),
              ]),
            ],
          ),
          h(
            UiComponentWrapper,
            {
              class: [
                'action',
                { 'is-video': props.record.forPersonalization && props.record.asset?.video },
                { signup: props.page.formType === null },
              ],
              style: props.record.forPersonalization
                ? {
                    height:
                      props.clientWidth >= 1024
                        ? '500px'
                        : `${
                            props.customizableImageSize / (2108 / 1500)
                          }px`,
                  }
                : undefined,
            },
            () => [
              h(
                UiComponentWrapper,
                {
                  class: 'headline',
                },
                () => [
                  h(UiComponentImage, {
                    class: 'flag fr',
                    alt: 'flag',
                    expectedSize: 16,
                    height: 16,
                    orientation: 'portrait',
                    source:
                      'https://livestorm.imgix.net/1127/1646403152-flag-of-france.svg',
                    width: 24,
                  }),
                  h(UiComponentImage, {
                    class: 'flag uk',
                    alt: 'flag',
                    expectedSize: 16,
                    height: 16,
                    orientation: 'portrait',
                    source:
                      'https://livestorm.imgix.net/1127/1646403153-flag-of-the-united-kingdom.svg',
                    width: 24,
                  }),
                  h(UiComponentImage, {
                    class: 'flag us',
                    alt: 'flag',
                    expectedSize: 16,
                    height: 16,
                    orientation: 'portrait',
                    source:
                      'https://livestorm.imgix.net/1127/1646403153-flag-of-the-united-states.svg',
                    width: 24,
                  }),
                  h(UiComponentParagraph, {
                    innerHTML:
                        'A Webinar Solution used by the best US companies for their business',
                    size: 's',
                  }),
                ],
              ),

              props.record.forPersonalization
              && h(UiComponentWrapper, { class: 'room' }, () => [
                h(UiComponentWrapper, { class: 'inner', key: `personalization-${props.customizableImageSize}` }, () => [
                  h(UiComponentImage, {
                    alt: 'Room',
                    class: 'base',
                    expectedSize: props.customizableImageSize,
                    height: 1500,
                    orientation:
                        props.clientWidth >= 1024
                          ? 'portrait'
                          : 'landscape',
                    source:
                        'https://livestorm.imgix.net/1127/1655132445-room-personalized.png',
                    width: 2108,
                  }),
                  h(UiComponentImage, {
                    alt: 'Your logo',
                    class: 'header-logo',
                    expectedSize:
                        props.clientWidth >= 1024
                          ? (63 / 1500) * props.customizableImageSize
                          : (63 / 2108) * props.customizableImageSize,
                    height: 63,
                    source:
                        'https://livestorm.imgix.net/1127/1655133365-add-logo.png',
                    style: {
                      borderRadius:
                          props.clientWidth >= 1024
                            ? `${
                                (18 / 1500) * props.customizableImageSize
                              }px`
                            : `${
                                (18 / 2108) * props.customizableImageSize
                              }px`,
                    },
                    width: 63,
                  }),
                  h(
                    UiComponentParagraph,
                    {
                      class: 'header-title',
                      style: {
                        fontSize:
                            props.clientWidth >= 1024
                              ? `${
                                  (24 / 1500) * props.customizableImageSize
                                }px`
                              : `${
                                  (24 / 2108) * props.customizableImageSize
                                }px`,
                      },
                    },
                    () => ['Live Q&A'],
                  ),
                  h(
                    UiComponentParagraph,
                    {
                      class: 'header-subtitle',
                      style: {
                        fontSize:
                            props.clientWidth >= 1024
                              ? `${
                                  (24 / 1500) * props.customizableImageSize
                                }px`
                              : `${
                                  (24 / 2108) * props.customizableImageSize
                                }px`,
                      },
                    },
                    () => ['Tuesday, October 26th - 3:00 PM'],
                  ),
                  h(UiComponentImage, {
                    alt: 'Slide',
                    class: 'slide',
                    expectedSize:
                        props.clientWidth >= 1024
                          ? (936 / 1500) * props.customizableImageSize
                          : (1485 / 2108) * props.customizableImageSize,
                    height: 936,
                    orientation:
                        props.clientWidth >= 1024
                          ? 'portrait'
                          : 'landscape',
                    source:
                        'https://livestorm.imgix.net/1127/1655196526-slide.png',
                    width: 1485,
                  }),
                  h('img', {
                    alt: 'Your logo',
                    class: 'slide-logo',
                    src: 'https://livestorm.imgix.net/1127/1655133367-your-company-logo.png',
                    style: {
                      height: `${
                          props.clientWidth >= 1024
                            ? (96 / 1500) * props.customizableImageSize
                            : (96 / 2108) * props.customizableImageSize
                        }px`,
                    },
                  }),
                  h(
                    UiComponentParagraph,
                    {
                      class: 'slide-subtitle',
                      style: {
                        fontSize:
                            props.clientWidth >= 1024
                              ? `${
                                  (36 / 1500) * props.customizableImageSize
                                }px`
                              : `${
                                  (36 / 2108) * props.customizableImageSize
                                }px`,
                        lineHeight:
                            props.clientWidth >= 1024
                              ? `${
                                  (48 / 1500) * props.customizableImageSize
                                }px`
                              : `${
                                  (48 / 2108) * props.customizableImageSize
                                }px`,
                      },
                    },
                    () => ['Q4 releases'],
                  ),
                  h(
                    UiComponentHeading,
                    {
                      as: 'paragraph',
                      class: 'slide-title',
                      level: 5,
                      style: {
                        fontSize:
                            props.clientWidth >= 1024
                              ? `${
                                  (60 / 1500) * props.customizableImageSize
                                }px`
                              : `${
                                  (60 / 2108) * props.customizableImageSize
                                }px`,
                        lineHeight:
                            props.clientWidth >= 1024
                              ? `${
                                  (84 / 1500) * props.customizableImageSize
                                }px`
                              : `${
                                  (84 / 2108) * props.customizableImageSize
                                }px`,
                      },
                    },
                    () => ['Live Q&A'],
                  ),
                ]),
              ]),

              !props.record.forPersonalization
              && !props.record?.asset?.video
              && props.record.asset
              && h(UiComponentImage, {
                alt: props.record.asset.alt,
                expectedSize: props.heroImageWidth,
                height: props.record.asset.height,
                source: props.record.asset.url,
                width: props.record.asset.width,
              }),

              !props.record.forPersonalization
              && props.record.asset?.video
              && props.record.asset?.video.streamingUrl
              && props.record.asset?.video.thumbnailUrl
              && h(OrganismPlayerVideo, {
                autoPlay: true,
                class: 'video-explainer',
                muted: true,
                posterSrc: props.record.asset.video.thumbnailUrl,
                subtitles:
                    props.record.addSubtitlesOnAVideo && props.record.subtitles
                      ? props.record.subtitles
                      : [],
                videoSrc: props.record.asset?.video.streamingUrl,
              }),

              !props.record.forPersonalization
              && !props.record.asset
              && !!props.page.formType
              && !(props.forms['demo'].hasBeenSubmitted || props.forms['watch-video'].hasBeenSubmitted)
              && (props.currentFormIndex === 0 || props.currentFormIndex === 1)
              && h(
                UiComponentWrapper,
                {
                  class: 'options',
                },
                () => [
                  h(
                    UiComponentWrapper,
                    {
                      class: [
                        'item',
                        { selected: props.currentFormIndex === 0 },
                      ],
                      onClick: () => {
                        props.setFormIndex(0)
                      },
                    },
                    () => [
                      h(
                        UiComponentImage,
                        {
                          alt: props.modelForm.demoOptionTitle,
                          class: 'icon',
                          expectedSize: 16,
                          height: 16,
                          source: 'https://livestorm.imgix.net/1127/1694504711-book-a-call.svg',
                          width: 16,
                        },
                      ),
                      h(
                        UiComponentWrapper,
                        {
                          class: 'description',
                        },
                        () => [
                          h(
                            UiComponentParagraph,
                            () => [
                              props.modelForm.demoOptionTitle,
                            ],
                          ),
                          h(
                            UiComponentParagraph,
                            () => [
                              props.modelForm.demoOptionText,
                            ],
                          ),
                        ],
                      ),
                    ],
                  ),
                  h(
                    UiComponentWrapper,
                    {
                      class: [
                        'item',
                        { selected: props.currentFormIndex === 1 },
                      ],
                      onClick: () => {
                        props.setFormIndex(1)
                      },
                    },
                    () => [
                      h(
                        UiComponentImage,
                        {
                          alt: props.modelForm.watchAVideoOptionTitle,
                          class: 'icon',
                          expectedSize: 16,
                          height: 16,
                          source: 'https://livestorm.imgix.net/1127/1694504712-watch-a-video.svg',
                          width: 16,
                        },
                      ),
                      h(
                        UiComponentWrapper,
                        {
                          class: 'description',
                        },
                        () => [
                          h(
                            UiComponentParagraph,
                            () => [
                              props.modelForm.watchAVideoOptionTitle,
                            ],
                          ),
                          h(
                            UiComponentParagraph,
                            () => [
                              props.modelForm.watchAVideoOptionText,
                            ],
                          ),
                        ],
                      ),
                    ],
                  ),
                ],
              ),

              !props.record.forPersonalization
              && !props.record.asset
              && !!props.page.formType
              && !props.forms[props.currentForm.slug].hasBeenSubmitted
              && props.currentFormIndex === -1
              && h(OrganismHubspotNativeForm, {
                formId: props.currentForm.formId,
                uniqueId: `landing-hero-${props.currentForm.slug}-form-${props.record.id}`,
                ['onHubspot:form:submitted']: submittedValues => props.onSubmitted(props.currentForm, submittedValues),
              }),

              !props.record.forPersonalization
              && !props.record.asset
              && !!props.page.formType
              && !props.forms['demo'].hasBeenSubmitted
              && props.currentFormIndex === 0
              && h(OrganismHubspotNativeForm, {
                formId: props.allForms.find(({ slug }) => slug === 'demo').formId,
                uniqueId: `landing-hero-demo-form-${props.record.id}`,
                ['onHubspot:form:submitted']: submittedValues => props.onSubmitted(props.allForms.find(({ slug }) => slug === 'demo'), submittedValues),
              }),

              !props.record.forPersonalization
              && !props.record.asset
              && !!props.page.formType
              && !props.forms['watch-video'].hasBeenSubmitted
              && props.currentFormIndex === 1
              && h(OrganismHubspotNativeForm, {
                formId: props.allForms.find(({ slug }) => slug === 'watch-video').formId,
                uniqueId: `landing-hero-watch-video-form-${props.record.id}`,
                ['onHubspot:form:submitted']: submittedValues => props.onSubmitted(props.allForms.find(({ slug }) => slug === 'watch-video'), submittedValues),
              }),

              !props.record.forPersonalization
              && !props.record.asset
              && !!props.page.formType
              && props.forms[props.currentForm.slug].hasBeenSubmitted
              && h(UiComponentWrapper, { class: 'success' }, () => [
                h(UiComponentParagraph, { slot: 'default' }, () => [
                  h('div', {
                    innerHTML: props.markdown.render(
                      props.currentForm.lastStepText || '',
                    ),
                  }),
                ]),
                !!props.currentForm.lastStepCta && h(
                  AtomButton,
                  {
                    to: props.currentForm.lastStepCta.slug,
                    size: 'l',
                  },
                  () => [props.currentForm.lastStepCta.slot],
                ),
              ]),

              !props.record.forPersonalization
              && !props.record.asset
              && props.page.formType === null
              && h(UiComponentWrapper, { class: 'head' }, () => [
                h(
                  UiComponentHeading,
                  {
                    as: 'paragraph',
                    level: 5,
                  },
                  () => 'Create your event in less than 3 minutes',
                ),
              ]),

              !props.record.forPersonalization
              && !props.record.asset
              && props.page.formType === null
              && h(
                'iframe',
                {
                  height: props.signupForm.height,
                  loading: 'lazy',
                  src: props.signupForm.url,
                  title: 'Livestorm Sign up',
                  width: '100%',
                },
                () => [],
              ),

              !props.record.forPersonalization
              && !props.record.asset
              && props.page.formType === null
              && h(UiComponentWrapper, { class: 'footer' }, () => [
                h(UiComponentParagraph, { size: 's' }, () => [
                  h(UiComponentIcon, { type: 'check' }),
                  'No credit card required',
                ]),
                h(UiComponentParagraph, { size: 's' }, () => [
                  h(UiComponentIcon, { type: 'check' }),
                  'No software to install',
                ]),
              ]),
            ],
          ),
        ],
      ),
      h(UiComponentContainer, { class: 'scroll-down' }, () => [
        h('img', {
          height: 15,
          src: assetSrc,
          width: 30,
        }),
      ]),
    ],
  )
}

Functional.props = {
  allForms: {
    required: true,
    type: Array,
  },
  clientWidth: {
    required: true,
    type: Number,
  },
  componentCertification: {
    required: true,
    type: Object,
  },
  currentForm: {
    required: false,
    type: Object,
  },
  currentFormIndex: {
    required: true,
    type: Number,
  },
  customersReviewLogoSection: {
    required: true,
    type: Object,
  },
  customizableImageSize: {
    required: true,
    type: Number,
  },
  forms: {
    required: true,
    type: Object,
  },
  isLogged: {
    required: true,
    type: Boolean,
  },
  mainButton: {
    required: true,
    type: Object,
  },
  markdown: {
    required: true,
    type: Object,
  },
  modelForm: {
    required: true,
    type: Object,
  },
  onSubmitted: {
    required: true,
    type: Function,
  },
  page: {
    required: true,
    type: Object,
  },
  primaryButton: {
    required: true,
    type: Object,
  },
  record: {
    required: true,
    type: Object,
  },
  secondaryButton: {
    required: true,
    type: Object,
  },
  setFormIndex: {
    required: true,
    type: Function,
  },
  signupForm: {
    required: true,
    type: Object,
  },
  teiStatistics: {
    required: true,
    type: Object,
  },
}

export default Functional
